import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VirtualGridService {
  private gridLifeCycle: EventEmitter<string> = new EventEmitter();

  get lifeCycle() {
    return this.gridLifeCycle;
  }
}
